import { create } from 'zustand'

export const useMixerStore = create((set) => ({
  deckA: null,
  deckB: null,

  setDeckA: (data) => set({ deckA: data }),
  setDeckB: (data) => set({ deckB: data }),

  clearDeckA: () => set({ deckA: null }),
  clearDeckB: () => set({ deckB: null }),

  updateDeckA: (updates) => set((state) => ({
    deckA: state.deckA ? { ...state.deckA, ...updates } : null
  })),

  updateDeckB: (updates) => set((state) => ({
    deckB: state.deckB ? { ...state.deckB, ...updates } : null
  })),
}))
